import store from '@state/store'
import { lazyLoadView } from '@utils/app/lazy-load-routes'
export default [
  {
    path: '/login',
    name: 'Login',
    component: () => lazyLoadView(import('@views/auth/auth-login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedInUser'] && store.getters['auth/aloggedInToken']) {
          // Redirect to the home page instead
          next({ name: 'Profile' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },

  {
    path: '/profile',
    name: 'Profile',
    component: () => lazyLoadView(import('@views/auth/auth-profile')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },

  {
    path: '/profile/:username',
    name: 'Username-Profile',
    component: () => lazyLoadView(import('@views/auth/auth-profile')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their username
          .dispatch('users/fetchUser', { username: routeTo.params.username })
          .then((user) => {
            // Add the user to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.user = user
            // Continue to the route.
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'User' } })
          })
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: (route) => ({ user: route.params.user }),
  },

  {
    path: '/logout',
    name: 'Logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'Home' } : { ...routeFrom })
      },
    },
  },
]
